export { default } from "./scene-compare.web";
